import { Header } from "@/components/SiteUI";
import { Button } from "@/components/ui/button";
import { Home, SearchX } from "lucide-react";
import SEO from "@/components/SEO/SEO";
import ShareButtons from "@/components/ui/share-buttons";


export const Page404 = () => {
    return (
        <>
            <SEO 
                title="Страница не найдена (404)"
                description="Страница не найдена. Вернитесь на главную страницу сайта психологической консультации в Минске."
                noindex={true}
            />
            <div
                className="size-full flex items-center justify-center p-6 mt-16"
            >
            <Header />
            <div className="max-w-2xl w-full flex flex-col items-center text-center">
                {/* Icon */}
                <div
                    className="mb-8 p-6 rounded-full bg-emerald-50"
                >
                    <SearchX
                        size={64}
                        className="text-emerald-900/50"
                    />
                </div>

                {/* 404 Text */}
                <div
                    className="mb-6 text-emerald-900/50"
                    style={{
                        fontSize: '8rem',
                        fontWeight: 700,
                        lineHeight: 1,
                        letterSpacing: '-0.02em'
                    }}
                >
                    404
                </div>

                {/* Heading */}
                <h1
                    className="mb-4 text-emerald-900"
                >
                    Страница не найдена
                </h1>

                {/* Description */}
                <p
                    className="mb-8 max-w-md opacity-70 text-emerald-900"
                >
                    К сожалению, страница, которую вы ищете, не существует или была перемещена.
                    Проверьте правильность адреса или вернитесь на главную страницу.
                </p>

                {/* Action Buttons */}
                <div className="flex gap-4 flex-wrap justify-center">
                    <Button
                        size="lg"
                        className="hover:opacity-90 transition-opacity"
                        onClick={() => window.location.href = '/'}
                    >
                        <Home className="mr-2" size={20} />
                        На главную
                    </Button>

                    <Button
                        size="lg"
                        variant="outline"
                        className="hover:opacity-70 transition-opacity"
                        onClick={() => window.history.back()}
                    >
                        Назад
                    </Button>
                </div>

                {/* Share Buttons */}
                <div className="mt-8 flex justify-center">
                    <ShareButtons 
                        title="Психологическая консультация в Минске"
                        description="Профессиональная психологическая помощь в Минске. Индивидуальные консультации, психологические тесты."
                        url="/"
                        showText={false}
                    />
                </div>

                {/* Additional Links */}
                <div className="mt-12 pt-8 border-t w-full" style={{ borderColor: 'hsl(18 38% 85%)' }}>

                </div>
            </div>
            </div>
        </>
    );
}